const naverMaps = window.naver.maps;
let prevActiveDiv = null;
let prevHtml = null;
let isInfoClicked = false;
const CustomOverlay = function(options) {
    const wrapDiv = document.createElement('div');
    wrapDiv.style.position = 'absolute';
    wrapDiv.style.left = '0px';
    wrapDiv.style.top = '0px';
    wrapDiv.style.transform = 'translate(-50%, -100%)';
    wrapDiv.style.willChange = 'transform';
    wrapDiv.innerHTML = options.html;
    wrapDiv.style.zIndex = 0;
    if(options.isPassTouch) wrapDiv.style.pointerEvents = 'none';
    if(options.zIndex) wrapDiv.style.zIndex = options.zIndex;
    if(options.clickAction){
        wrapDiv.addEventListener('click', () => {
            isInfoClicked = true;
            if(prevActiveDiv){
                prevActiveDiv.innerHTML = prevHtml;
                prevActiveDiv.style.zIndex = 0;
            }
            prevActiveDiv = wrapDiv;
            prevHtml = options.html;
            wrapDiv.innerHTML = options.activeHtml;
            wrapDiv.style.zIndex = 1;
            options.clickAction(wrapDiv);
        });
    }
    if (options.touchStart) {
        wrapDiv.addEventListener('touchstart', () => {
            options.touchStart(wrapDiv)
        })
    }
    if (options.touchEnd) {
        wrapDiv.addEventListener('touchend', () => {
            options.touchEnd(wrapDiv)
        })
    }

    this.element = wrapDiv;

    this.setPosition(options.position);
    this.setMap(options.map || null);
};

// CustomOverlay는 OverlayView를 상속받습니다.
CustomOverlay.prototype = new naverMaps.OverlayView();
CustomOverlay.prototype.constructor = CustomOverlay;
CustomOverlay.prototype.onAdd = function() {
    var overlayLayer = this.getPanes().overlayLayer;
    overlayLayer.append(this.element);
};
// CustomOverlay.prototype.setHtml = function(){
//     this.element.innerHTML = "<div>test</div>";
//     this.draw();
// }
CustomOverlay.prototype.draw = function() {
    // 지도 객체가 설정되지 않았으면 draw 기능을 하지 않습니다.
    if (!this.getMap()) {
        return;
    }

    var projection = this.getProjection(), position = this.getPosition();
    var pixelPosition = projection.fromCoordToOffset(position);

    this.element.style.left = pixelPosition.x + 'px';
    this.element.style.top = pixelPosition.y + 'px';
};

CustomOverlay.prototype.onRemove = function() {
    this.element.remove();

    // 이벤트 핸들러를 설정했다면 정리합니다.
    // this.element.off();
};

CustomOverlay.prototype.setPosition = function(position) {
    this._position = position;
    this.draw();
};

CustomOverlay.prototype.getPosition = function() {
    return this._position;
};

class NaverMap {
    getMapInstance() { return this.#map;}
    #map;
    #overlays = {};
    #myMarker;
    #curClustering;
    static MAP_TYPE = {
        BRANCH: 0,
        COACH: 1,
    }

    static MARKER_TYPE = {
        DEFAULT : 0,
        RECRUTING : 1,
    }

    constructor(){

    }

    initMap(id, lat, lng, customOptions = null){
        let center = new naverMaps.LatLng(lat, lng);

        const options = {
            center: center,
            zoom: 15,
            draggable : true,
            mapDataControl : false,
            pinchZoom : true,
            scrollWheel : true,
            disableKineticPan : false,
            scaleControl : false,
            logoControl : false,
            tileSpare : 0,
            // overlayZoomEffect : 'all'
        };

        if(customOptions) Object.assign(options, customOptions);

        this.#map = new naverMaps.Map(id, options);
    }

    addDragEndListener(callback){
        naverMaps.Event.addListener(this.#map, 'dragend', () => {
            // const latlng = this.#map.getCenter();
            // this.getBounds();
            // const {maxlat, maxlng, minlat, minlng} = this.getBounds();
            callback();
        });
    }

    mapClickEvent(callback) {
        naverMaps.Event.addListener(this.#map, 'click', () => {
            callback()
        })
    }

    addZoomChangedListener(callback){
        naverMaps.Event.addListener(this.#map, 'zoom_changed', (zoom) => {
            // const latlng = this.#map.getCenter();
            // this.getBounds();
            // const {maxlat, maxlng, minlat, minlng} = this.getBounds();
            callback(zoom);
        });
    }
    addMapClickListner(callback){
        naverMaps.Event.addListener(this.#map, 'click', () => {
            setTimeout(() => {
                if(!isInfoClicked) {
                    callback();
                    if(prevActiveDiv){
                        prevActiveDiv.innerHTML = prevHtml;
                    }
                }
                isInfoClicked = false;
            }, 1)
        });
    }

    getBounds(){
        const bounds = this.#map.getBounds();
        return {
            maxlat : bounds.maxX(),
            maxlng : bounds.maxY(),
            minlat : bounds.minX(),
            minlng : bounds.minY()
        };
    }

    //커스텀 오버레이 생성
    drawOverlay(html, lat, lng, activeHtml, clickAction, zIndex = 0, touchStart, touchEnd){
        // console.log(lat + ',' + lng);
        if(Object.prototype.hasOwnProperty.call(this.#overlays, lat + '-' + lng)){
            return;
        }

        const overlay = new CustomOverlay({
            position: new naverMaps.LatLng(lat, lng),
            map: this.#map,
            html : html,
            activeHtml : activeHtml,
            clickAction : clickAction,
            zIndex : zIndex,
            touchStart: touchStart,
            touchEnd: touchEnd
        });

        this.#overlays[lat + '-' + lng] = overlay;
    }

    drawMyLocationMarker(html, lat, lng, isPassTouch = false, activeHtml, clickAction = null){
        if(this.#myMarker) this.#myMarker.setMap(null);

        const overlay = new CustomOverlay({
            position: new naverMaps.LatLng(lat, lng),
            map: this.#map,
            html : html,
            activeHtml : activeHtml,
            clickAction : clickAction,
            zIndex : 2,
            isPassTouch : isPassTouch
        });

        this.#myMarker = overlay;
    }

    setCenter(lat, lng){
        this.#map.setCenter(naverMaps.LatLng(lat, lng));
    }
    panTo(lat, lng){
        this.#map.panTo(naverMaps.LatLng(lat, lng));
    }

    clear(){
        for(const key in this.#overlays){
            this.#overlays[key].setMap(null);
        }

        this.#overlays = {};
        prevActiveDiv = null
    }

    async getAddressByLatLng(lat, lng){
        const v2 = await this.#getGecodeByLatLng(lat, lng);
        return v2.address.jibunAddress;
    }

    async getRegionByLatLng(lat, lng){
        const v2 = await this.#getGecodeByLatLng(lat, lng);
        return {
            code : v2.results[0].code.id,
            address : v2.address.jibunAddress
        }
        ;
    }


    #getGecodeByLatLng(lat, lng){
        // lat = 37.3595316;
        // lng = 127.1052133;
        let latlng = new naverMaps.LatLng(lat, lng);

        return new Promise((resolve) => {
            naverMaps.Service.reverseGeocode({
                coords: latlng,
                orders: [
                    // naverMaps.Service.OrderType.ADDR,
                    // naverMaps.Service.OrderType.ROAD_ADDR,
                    naverMaps.Service.OrderType.LEGAL_CODE
                ].join(',')
            }, function(status, response) {
                console.log(response);

                if (status === naverMaps.Service.Status.ERROR) {
                    if (!latlng) {
                        return alert('ReverseGeocode Error, Please check latlng');
                    }
                    if (latlng.toString) {
                        return alert('ReverseGeocode Error, latlng:' + latlng.toString());
                    }
                    if (latlng.x && latlng.y) {
                        return alert('ReverseGeocode Error, x:' + latlng.x + ', y:' + latlng.y);
                    }
                    return alert('ReverseGeocode Error, Please check latlng');
                }

                // var address = response.v2.address;

                // console.log();
                // if (address.jibunAddress !== '') {
                //     htmlAddresses.push('[지번 주소] ' + address.jibunAddress);
                // }
                //
                // if (address.roadAddress !== '') {
                //     htmlAddresses.push('[도로명 주소] ' + address.roadAddress);
                // }
                //
                // return

                resolve(response.v2);
            });
        });
    }

    setCenterMarker(lat, lng, markerType = null){
        // const marker = naverMaps.Marker({
        //     position: new naverMaps.LatLng(lat, lng),
        //     map: this.#map
        // });

        // let url = '/img/map_marker.png';
        let url = '';
        if(markerType && markerType === NaverMap.MARKER_TYPE.RECRUTING) url = '/img/map_marker_recruiting.png';

        new naverMaps.Marker({
            position: new naverMaps.LatLng(lat, lng),
            map: this.#map,
            icon: {
                url: url,
            }
        });
    }

    enlargeMap(){
        this.#map.setZoom(this.#map.getZoom() + 1);
    }
    l = 0;
    addClustering(gpsData){
        // let gpsData = [];

        // for(let i = 0; i < 200; i++){
        //     for(let j = 0; j < 200; j++) {
        //         gpsData.push({gps_latitude: 33.0 + 0.1 * i, gps_longitude: 127.079 + 0.1 * j});
        //     }
        // }
        // var gpsData
        // if(this.l % 2 === 0){
        //     gpsData = [
        //         {gps_latitude : 35.1961, gps_longitude : 129.0794},
        //         {gps_latitude : 35.7, gps_longitude : 129.0794002},
        //         {gps_latitude : 35.8, gps_longitude : 129.0794002},
        //         {gps_latitude : 35.9, gps_longitude : 129.0794002},
        //         {gps_latitude : 35.6, gps_longitude : 129.0794002},
        //     ];
        // }else {
        //     gpsData = [
        //         {gps_latitude : 34.1961, gps_longitude : 129.0794},
        //         {gps_latitude : 34.7, gps_longitude : 129.0794002},
        //         {gps_latitude : 34.8, gps_longitude : 129.0794002},
        //         {gps_latitude : 34.9, gps_longitude : 129.0794002},
        //         {gps_latitude : 34.6, gps_longitude : 129.0794002},
        //     ];
        // }


        const markers = [];

        for (let i = 0; i < gpsData.length; i++) {
            const gps = gpsData[i];
            const latlng = new naverMaps.LatLng(gps.gps_latitude, gps.gps_longitude);
            const marker = new naverMaps.Marker({
                position: latlng,
                draggable: true,
                icon: {
                    content : '<div style="border-radius:50%; width:8px; height:8px; background-color: #6544d9;"></div>'
                }
            });
            markers.push(marker);
        }

        const marker1 = {
            content : `<div style="border-radius:50%; background-color: #6544d9cc; width:30px;height:30px;color:white; line-height:30px; font-size:15px; text-align:center;"></div>`,
            size: new naverMaps.Size(24, 37),
            origin: new naverMaps.Point(90, 0),
            anchor: new naverMaps.Point(12, 37)
        };

        const marker2 = {
            content : `<div style="border-radius:50%; background-color: #6544d9cc; width:36px;height:36px;color:white; line-height:36px; font-size:15px; text-align:center;"></div>`,
            size: new naverMaps.Size(24, 37),
            origin: new naverMaps.Point(90, 0),
            anchor: new naverMaps.Point(12, 37)
        };

        const marker3 = {
            content : `<div style="border-radius:50%; background-color: #6544d9cc; width:42px;height:42px;color:white; line-height:42px; font-size:15px; text-align:center;"></div>`,
            size: new naverMaps.Size(24, 37),
            origin: new naverMaps.Point(90, 0),
            anchor: new naverMaps.Point(12, 37)
        };

        const marker4 = {
            content : `<div style="border-radius:50%; background-color: #6544d9cc; width:48px;height:48px;color:white; line-height:48px; font-size:15px; text-align:center;"></div>`,
            size: new naverMaps.Size(24, 37),
            origin: new naverMaps.Point(90, 0),
            anchor: new naverMaps.Point(12, 37)
        };

        const marker5 = {
            content : `<div style="border-radius:50%; background-color: #6544d9cc; width:54px;height:54px;color:white; line-height:54px; font-size:15px; text-align:center;"></div>`,
            size: new naverMaps.Size(24, 37),
            origin: new naverMaps.Point(90, 0),
            anchor: new naverMaps.Point(12, 37)
        };

        /*eslint-disable no-undef */
        this.#curClustering = new MarkerClustering({
            minClusterSize: 1,
            maxZoom: 10,
            map: this.#map,
            markers: markers,
            disableClickZoom: false,
            gridSize: 120,
            icons: [marker1, marker2, marker3, marker4, marker5],
            indexGenerator: [10, 100, 200, 500, 1000],
            stylingFunction: function(clusterMarker, count) {
                $(clusterMarker.getElement()).find('div:first-child').text(count);
            }
        });
    }

    removeClustering(){
        if(this.#curClustering) {
            // this.#curClustering._clearClusters();
            this.#curClustering.setMap(null);
        }
    }

    getZoomLevel(){
        return this.#map.getZoom()
    }

    test(){
        this.#map.setZoom(13, false);
    }
}


export default NaverMap;
